import { combineReducers } from "@reduxjs/toolkit";
import campaignDetailsReducer from "./campaignDetails/campaignDetails.slice";
import campaignActivitiesReducer from "./campaignActivities/campaignActivities.slice";
import campaignDonorsReducer from "./campaignDonors/campaignDonors.slice";
import campaignPostsReducer from "./campaignPosts/campaignPosts.slice";
import createCampaignReducer from "./campaignCreation/createCampaign.slice";
import campaignLeaderDonorsReducer from "./campaignLeaderDonors/campaignLeaderDonors.slice";


const campaingsReducer = combineReducers({
    campaignDetails: campaignDetailsReducer,
    campaignActivities: campaignActivitiesReducer,
    campaignDonors: campaignDonorsReducer,
    campaignPosts: campaignPostsReducer,
    createCampaign: createCampaignReducer,
    campaignLeaderDonors: campaignLeaderDonorsReducer,
})

export default campaingsReducer